import api from '../../utils/api'

export const state = {
  importedFiles: [],
  importedFileMeta: []
}

export const mutations = {
  SET_IMPORTED_FILES(state, importedFiles) {
    state.importedFiles = importedFiles
  },
  SET_IMPORTED_FILE_META(state, importedFileMeta) {
    state.importedFileMeta = importedFileMeta
  }
}

export const actions = {
  async handleCreate(_, body) {
    try {
      return await api.post('/imported-file', body)
    } catch (error) {

    }
  },

  async handleGetAllPaginated({ commit }, payload) {
    try {
      let params = {}

      if (payload) {
        params = {
          skip: payload.skip || 0,
          limit: payload.limit || 10,
          startDate: payload.startDate || null,
          endDate: payload.endDate || null,
          filter: payload.filter || '',
        }
      }

      const { data: response } = await api.get('/imported-file', { params })
      if (response && response.items) {
        commit('SET_IMPORTED_FILES', response.items)
        commit('SET_IMPORTED_FILE_META', response.meta)
      } else {
        commit('SET_IMPORTED_FILES', [])
        commit('SET_IMPORTED_FILE_META', {})
      }
    } catch (err) {
    }
  },

  handleResetMeta: ({ commit }) => commit('SET_IMPORTED_FILE_META', {
    startDate: null,
    endDate: null,
    filter: '',
    limit: 10,
  }),
}

export const getters = {
  importedFiles: (state) => state.importedFiles,
  importedFileMeta: (state) => state.importedFileMeta
}
